import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../service/admin.service";
import {LoadingController, ModalController, NavParams, ToastController} from "@ionic/angular";
import {Constant} from "../../shared/model/Constant";

@Component({
  selector: 'app-user-profiles',
  templateUrl: './user-profiles.page.html',
  styleUrls: ['./user-profiles.page.scss'],
})
export class UserProfilesPage implements OnInit {
  loading: any;
  profiles: any[] = [];
  profileId: any;
  permissions: any;
  profilesPermissions = [];
  userId: any;
  userSelected: any;

  constructor(private adminService: AdminService,
              public loadingController: LoadingController,
              public modalController: ModalController,
              public toastController: ToastController,
              public navParams: NavParams
  ) {
  }

  async ngOnInit() {
    this.userSelected = this.navParams.get('user');
    this.userId = JSON.parse(localStorage.getItem(Constant.userId));

    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    await this.getProfiles();
    this.getProfilesByUser(this.userSelected.userId);
  }

  async close(data?) {
    await this.modalController.dismiss(data);

  }

  getProfiles() {
    this.loading.present();
    this.adminService.getAllProfile().subscribe((profiles: any) => {
      this.profiles = profiles;
      this.loading.dismiss();
    });
  }

  addProfile(form?: any) {
    const body = {
      userId: this.userSelected.userId,
      profileId: form.profileId,
      watch: form.permissions.includes('ver'),
      edit: form.permissions.includes('editar'),
      delete: form.permissions.includes('eliminar'),
      profileLabel: this.profiles.filter(i => i.profileId === form.profileId)[0].name,
      userRegisterId: this.userId
    };
    this.loading.present();
    this.profilesPermissions.push(body);
    this.adminService.createUserProfile(body).subscribe((res: any) => {
      if (res && res.userprofileId) {
        this.presentToast('Asociación exitosa');
      }
      this.loading.dismiss();
    }, (error: any) => {
      this.loading.dismiss();
      console.warn(error);
      this.presentToast('No fue posible asociar el módulo');
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  getProfilesByUser(userId) {
    this.loading.present();
    this.adminService.getProfilesByUser(userId).subscribe((res: any[]) => {
      if (res && res.length > 0) {
        res.forEach(item => {
          item.profileLabel = this.profiles.filter(i => i.profileId === item.profileId)[0].name;
          item.view = item.watch;
        });
        this.profilesPermissions = res;
      }
      this.loading.dismiss();
    });
  }
}
